module.exports = __webpack_public_path__ + "img/img2.26ca1a3c.jpg";